import Image from 'next/image';
import imageLoading from '@/img/loading.svg';

const Loading = () => {
  return (
    <div>
      <Image
        src={imageLoading}
        width={20}
        height={20}
        alt="Imagem de um Loading"
      />
    </div>
  );
};

export default Loading;
